<template>
  <div class="prescriptionData">
    <!-- “prescriptionData”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="searchForm"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @formulaNoChange="formulaNoChange"
      @productCodeChange="productCodeChange"
      @searchBtnClick="searchBtnClick"
      @changeCompany="changeCompany"
    >
    </sirui-search>
    <!-- prescriptionData -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span
              v-else-if="item.field === 'productNameJoining' || item.field === 'productNameSpec'"
            >
              <p class="color" v-on:click.prevent="clickProductName(scope)">{{
                scope.row[item.field]
              }}</p>
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <detail ref="dialog" />
    <!-- 详情 -->
    <!-- 导入 -->
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="SysFormula"
    ></sirui-upload>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/productCenter/prescriptionData';
  import DataBaseAPI from '@/api/dataBase';
  import tableMixins from '@/common/mixins/table.js';
  // import DictSpan from '@/components/DictSpan';
  import siruiUpload from '@/components/SiruiUpload';
  // import SearchTable from '@/components/form-item/search-table';
  import detail from './detailsQuery';
  import XEUtils from 'xe-utils';
  // import API from "@/api/masterData/rawQuery";
  import baseUrl from '@/common/config';
  export default {
    mixins: [tableMixins],
    name: 'add',
    components: {
      siruiUpload,
      detail,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      baseUrl() {
        return baseUrl;
      },
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          //   大类
          {
            name: this.$t('prescriptionList.search.formulaCategory'),
            prop: 'formulaCategory',
            type: 'dict',
            dictType: 'formula_category',
          },
          //   规格型号
          {
            name: this.$t('prescriptionList.search.productModel'),
            prop: 'productModel',
            type: 'input',
            // querySearch: this.productModelSearch
            // placeholder: this.$t('rawData.search.productCode'),
          },
          //   花纹
          {
            name: this.$t('prescriptionList.search.figureType'),
            prop: 'figureType',
            type: 'input',
            //  querySearch: this.figureTypeSearch
          },
          //   配料描述
          {
            name: this.$t('prescriptionList.search.materialDesc'),
            prop: 'productName',
            type: 'input',
            // querySearch: this.productConfirmNameSearch
          },
          //   商品描述
          {
            name: this.$t('prescriptionList.search.productCode'),
            prop: 'productCode',
            type: 'searchTableSpec',
            searchType: 'produceProduct',
            currentValue: this.searchForm.productCode,
            changeMethod: 'productCodeChange',
            isMultiple: true,
            extraData: {
              productClass: '1',
            },
            // querySearch: this.productNameSearch
          },
          //   配料状态
          {
            name: this.$t('prescriptionList.search.statusFlag'),
            prop: 'statusFlag',
            type: 'dict',
            dictType: 'formula_status',
          },
          //   配方编号
          {
            name: this.$t('prescriptionList.search.formulaNo'),
            prop: 'formulaNo',
            type: 'searchTableSpec',
            searchType: 'produceFurmula',
            changeMethod: 'formulaNoChange',
            isMultiple: true,
          },
        ];
      },
    },
    data() {
      return {
        SysFormula: {}, // 导入参数
        action: API.IMPORT_FORMULA, // 导入地址
        searchForm: {
          companyName: '',
          productName: '',
          formulaCategory: '',
          productModel: '',
          figureType: '',
          basicUnit: '',
          weight: '',
          formulaUsage: '',
          departmentName: '',
          gmtCreate: '',
          createBy: '',
          productSpec: '',
          productBrand: '',
          formulaNo: '',
          productCode: '',
          statusFlag: '',
        },
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          {
            field: 'formulaNo',
            title: 'prescriptionList.table.formulaNo',
            visible: true,
            width: 140,
          },
          {
            field: 'productNameJoining',
            title: 'prescriptionList.table.productName',
            visible: true,
            width: 180,
          },
          {
            field: 'statusFlag',
            title: 'prescriptionList.table.statusFlag',
            visible: true,
            width: 140,
            dictType: 'formula_status',
          },
          {
            field: 'formulaCategory',
            title: 'prescriptionList.table.formulaCategory',
            visible: true,
            width: 140,
            dictType: 'formula_category',
          },
          {
            field: 'productModel',
            title: 'prescriptionList.table.productModel',
            visible: true,
            width: 140,
          },
          {
            field: 'figureType',
            title: 'prescriptionList.table.figureType ',
            visible: true,
            width: 140,
          },
          { field: 'productNameSpec', title: 'prescriptionList.table.materialDesc', visible: true },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
      this.setImport(),
        this.$nextTick(() => {
          //设置导入参数
          this.setImport();
        });
      // this.getDictList();
      /* this.getFormulaCategoryList(),
    this.getProductModelList(),
    this.getFigureTypeList(),
    this.getProductCodeList(),
    this.getProductNameList(),
    this.getProductConfirmNameList() */
    },
    methods: {
      // 获取列表数据
      getData() {
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const { adminFlag, tenantCode } = this.userInfo;
        let params = { pageNum, pageSize, adminFlag, tenantCode };
        params = Object.assign(params, this.searchForm);
        this.$axios.post(API.LIST_FUND_COLLECTION_REGISTER_BY_PAGE, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      formulaNoChange(val) {
        // 切换期间
        let res = val.val;
        if (res && res.length > 0) {
          this.searchForm.formulaNo = res[0].formulaNo;
        } else {
          this.searchForm.formulaNo = null;
        }
      },
      productCodeChange(val) {
        // 切换期间
        let res = val.val;
        if (res && res.length > 0) {
          this.searchForm.productCode = res[0].productCode;
        } else {
          this.searchForm.productCode = null;
        }
      },
      clickProductName(e) {
        this.$refs.dialog.openDialog(e);
      },
      // 获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      // 获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      // 获取大类列表
      getFormulaCategoryList() {
        const params = {
          cloumn: 'formulaCategory',
        };
        this.$axios.get(API.SELECT_OPTION_FORMULA, params).then((res) => {
          if (res.data.code === 0) {
            this.formulaCategoryList = res.data.data;
          }
        });
      },
      // 获取规格型号列表
      getProductModelList() {
        const params = {
          cloumn: 'productModel',
        };
        this.$axios.get(API.SELECT_OPTION_FORMULA, params).then((res) => {
          if (res.data.code === 0) {
            this.productModelList = res.data.data;
          }
        });
      },
      // 获取花纹列表
      getFigureTypeList() {
        const params = {
          cloumn: 'figureType',
        };
        this.$axios.get(API.SELECT_OPTION_FORMULA, params).then((res) => {
          if (res.data.code === 0) {
            this.figureTypeList = res.data.data;
          }
        });
      },
      // 获取原料编号列表
      getProductCodeList() {
        const params = {
          cloumn: 'productCode',
        };
        this.$axios.get(API.SELECT_OPTION_FORMULA, params).then((res) => {
          if (res.data.code === 0) {
            this.productCodeList = res.data.data;
          }
        });
      },
      // 获取原料名称列表
      getProductNameList() {
        const params = {
          cloumn: 'productName',
        };
        this.$axios.get(API.SELECT_OPTION_FORMULA, params).then((res) => {
          if (res.data.code === 0) {
            this.productNameList = res.data.data;
          }
        });
      },
      // 校准名称列表
      getProductConfirmNameList() {
        const params = {
          cloumn: 'product_name',
        };
        this.$axios.get(API.SELECT_OPTION_FORMULA, params).then((res) => {
          if (res.data.code === 0) {
            this.productConfirmNameList = res.data.data;
          }
        });
      },
      // 大类模糊查询
      formulaCategorySearch(queryString, cb) {
        const formulaCategoryList = this.formulaCategoryList;
        const results = queryString
          ? formulaCategoryList.filter(this.createFilter(queryString))
          : formulaCategoryList;
        cb(results);
      },
      // 规格型号模糊查询
      productModelSearch(queryString, cb) {
        const productModelList = this.productModelList;
        const results = queryString
          ? productModelList.filter(this.createFilter(queryString))
          : productModelList;
        cb(results);
      },
      // 花纹模糊查询
      figureTypeSearch(queryString, cb) {
        const figureTypeList = this.figureTypeList;
        const results = queryString
          ? figureTypeList.filter(this.createFilter(queryString))
          : figureTypeList;
        cb(results);
      },
      // 原料编号模糊查询
      productCodeSearch(queryString, cb) {
        const productCodeList = this.productCodeList;
        const results = queryString
          ? productCodeList.filter(this.createFilter(queryString))
          : productCodeList;
        cb(results);
      },
      // 原料名称模糊查询
      productNameSearch(queryString, cb) {
        const productNameList = this.productNameList;
        const results = queryString
          ? productNameList.filter(this.createFilter(queryString))
          : productNameList;
        cb(results);
      },
      // 校准名称模糊查询
      productConfirmNameSearch(queryString, cb) {
        const productConfirmNameList = this.productConfirmNameList;
        const results = queryString
          ? productConfirmNameList.filter(this.createFilter(queryString))
          : productConfirmNameList;
        cb(results);
      },
      createFilter(queryString) {
        return (data) => {
          return data.value.indexOf(queryString) !== -1;
        };
      },
      getDictList() {
        // 公司名称
        this.$axios
          .get(DataBaseAPI.LISTDATA_SERECHCOMPANY + `/${this.userInfo.userInfo.tenantCode}`)
          .then((res) => {
            if (res.data.code == 0) {
              this.slipCompanyList = res.data.data;
            }
          });
      },
      chooseClick(value) {
        if (value === 'add') {
          //增加
          this.handleAdd();
        } else if (value === 'importData') {
          //批量导入
          this.handleImport();
        } else if (value === 'del') {
          //批量删除
          this.handleForbid();
        } else if (value === 'exportData') {
          //批量导出
          this.handleExport();
        }
      },
      // 新增
      handleAdd() {
        let path = {
          path: '/production/prescriptionDataAdd',
          name: 'prescriptionDataAdd',
          meta: {
            keepAlive: true,
            title: '新增物料配方主数据明细',
          },
          query: {},
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 导出
      handleExport() {
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'error',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = 'idList=';
          // let ids = changeList.forEach((item) => {
          //   str += '' + item.id + ',';
          // });
          str = str.substring(0, str.lastIndexOf(','));
          window.location.href = `${this.baseUrl}${API.EXPORT_FORMULA}?${str}&access_token=${this.token.access_token}`;
        } else {
          const params = XEUtils.serialize(this.searchForm);
          window.location.href = `${this.baseUrl}${API.EXPORT_FORMULA}?${params}&access_token=${this.token.access_token}`;
        }
      },
      handleForbid() {
        if (this.multipleSelection.length > 0) {
          let ids = [];
          for (let item of this.multipleSelection) {
            if (item.statusFlag !== '001') {
              ids.push(item.id);
            } else {
              this.$message({
                showClose: true,
                message: this.$t('prescriptionList.message.delete_to_enable'),
                type: 'error',
              });
              return false;
            }
          }
          this.$confirmAction(this.$t('confirm.delete'))
            .then(() => {
              this.$axios.post(API.DELETE_FORMULA, ids).then((res) => {
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: this.$t('prescriptionList.message.deleteSuccess'),
                    type: 'success',
                  });
                  this.multipleSelection = [];
                  this.$refs.siruiTable.clearCheckboxRow();
                  this.resetBtnClick();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('prescriptionList.message.pleaseSelectOne'),
            type: 'error',
          });
        }
      },
      // 设置导入配置
      setImport() {
        let { tenantCode, access_token, companyCode, companyName, departmentCode, departmentName } =
          this.userInfo;
        this.SysFormula = {
          tenantCode,
          access_token,
          companyCode,
          companyName,
          departmentCode,
          departmentName,
        };
      },
      // 批量导入
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true);
      },
      dblclickEvent(e) {
        this.$baseRequest.linkRouteUrl(
          '/production/prescriptionDataAdd',
          'prescriptionDataAdd',
          '修改物料主数据明细',
          { id: e.row.id, isEdit: 'Y' }
        );
      },
      changeCompany() {},
    },
  };
</script>
<style lang="scss" scoped>
  .prescriptionData .color {
    color: #0071fe;
    cursor: pointer;
  }
</style>
